module.exports = __webpack_public_path__ + "static/media/correct_columns.d70b188a.png";